import { render } from "./OverviewStats.vue?vue&type=template&id=1f547da2&scoped=true"
import script from "./OverviewStats.vue?vue&type=script&lang=js"
export * from "./OverviewStats.vue?vue&type=script&lang=js"

import "./OverviewStats.vue?vue&type=style&index=0&id=1f547da2&lang=stylus&scoped=true"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-1f547da2"]])

export default __exports__